import * as types from "../types";

const INITIAL_STATE = {
  setCurrPage: -1,
  currPage: 0,
  chosenTab: 1,
  totSTR: "",
  selectedSortOption: "1",
  Qty: undefined,
  orderID: undefined,
  showBasketItems: false,
  minOrd: { MIN_ORD: 0, MESSAGE: "" },
  IsFreeDlv: false,
  //topRightItem: undefined,
  items: [],
  categories: [],
  filters: [],
  brands: [],
  filtersVisible: false,
  brandsVisible: false,
  priceFilterVisible: false,
  availableFilterVisible: false,
  otherImages: [],
  showAvailableItems: true,
  showUnavailableItems: false,
  fromPrice: "",
  toPrice: "",
  day: new Date().getDay(),
  month: new Date().getMonth() + 1,
  year: new Date().getFullYear(),
  selectedItemIndex: -1,
  selectedItem: {},
  deliveryTimes: [],
  datePickerVisible: false,
  date: undefined,
  time: "",
  user: "",
  address: "",
  category: "",
  sortBy: "",
  categoryItems: {},
  isCategories: true,
  phoneNumber: "",
  SubTot: 0,
  Disc: 0,
  Tax: 0,
  Net: 0,
  credit: 0,
  badgeText: 0,
  orderNote: "",
  freeDlvNote: "",
  addressNote: "",
  fromSetupOrder: false,
  userInfoConfirmed: false,
  payment_method: "ONLINE",
  isGift: false,
  userLocation: {
    latitude: 31.9454,
    longitude: 35.9284,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421,
  },
  initialMapRegion: {
    latitude: 31.9454,
    longitude: 35.9284,
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421,
  },
  pickupAddress: "Pick up ( Khansa street bilbeisi building )",
  pickupLocation: {
    latitude: 31.941147,
    longitude: 35.83509,
  },
  showMap: false,
  showCachedMap: false,
  cachedMapKey: 1,
  language: "",
  promoCode: "",
  recipient: "",
  recipientMobile: "",
  deliveryCharge: 0,
  alertMessage: "",
  categoriesMessage: "",
};

const getItemIndexInList = (mItems, item) => {
  for (let i = 0; i < mItems.length; i++) {
    const mItem = mItems[i];
    if (mItem.ID === item.ID) {
      return i;
    }
  }
  return -1;
};

const updateItems = (curItems, itemsToUpdate, fromSetupOrder = false) => {
  for (let i = 0; i < curItems.length; i++) {
    const curItem = curItems[i];
    const itemIndex = getItemIndexInList(itemsToUpdate, curItem);
    if (itemIndex !== -1) {
      const itemToUpdate = itemsToUpdate[itemIndex];
      curItems[i].Qty = itemToUpdate.Qty;
      curItems[i].Tax = itemToUpdate.Tax;
      curItems[i].Price = itemToUpdate.Price;
      curItems[i].Bonus = itemToUpdate.Bonus;
      curItems[i].Disc = itemToUpdate.Disc;
      curItems[i].TotDisc = itemToUpdate.TotDisc;
      curItems[i].SubItems = itemToUpdate.SubItems;
      curItems[i].HideSubItems = itemToUpdate.HideSubItems;
      if (fromSetupOrder) {
        curItems[i].Note = itemToUpdate.Note;
      }
    }
  }
};

const clearBasket = (curItemsCB) => {
  for (let i = 0; i < curItemsCB.length; i++) {
    curItemsCB[i].Qty = 0;
    curItemsCB[i].Bonus = 0;
    curItemsCB[i].Note = 0;
  }
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.DELIVERY_UPDATE_STATE:
      return { ...state, ...action.payload };
    case types.DELIVERY_LOAD_ITEMS:
      return { ...state, items: action.payload };
    case types.DELIVERY_CALC_ORDER:
      const curItemsCO = state.items.slice();
      updateItems(curItemsCO, action.payload.Lines);
      return {
        ...state,
        items: curItemsCO,
        SubTot: action.payload.SubTot,
        Disc: action.payload.Disc,
        Tax: action.payload.Tax,
        Net: action.payload.Net,
        credit: action.payload.credit,
        deliveryCharge: action.payload.deliveryCharge,
      };
    case types.DELIVERY_SETUP_ORDER:
      const curItemsSO = state.items.slice();
      updateItems(curItemsSO, action.payload.items, true);
      return {
        ...state,
        items: curItemsSO,
        SubTot: action.payload.SubTot,
        Disc: action.payload.Disc,
        Tax: action.payload.Tax,
        Net: action.payload.Net,
        credit: action.payload.credit,
        deliveryCharge: action.payload.deliveryCharge,
        orderNote: action.payload.orderNote,
        addressNote: action.payload.addressNote,
        address: action.payload.address,
        phoneNumber: action.payload.phoneNumber,
        badgeText: action.payload.items.length,
        time: action.payload.time,
        userLocation: action.payload.userLocation,
        fromSetupOrder: action.payload.fromSetupOrder,
        orderID: action.payload.orderID,
      };
    case types.DELIVERY_CLEAR_BASKET:
      const curItemsCB = state.items.slice();
      clearBasket(curItemsCB);
      return {
        ...state,
        items: curItemsCB,
        badgeText: 0,
        orderNote: "",
        addressNote: "",
        totSTR: "",
        SubTot: 0,
        Disc: 0,
        Tax: 0,
        Net: 0,
        credit: 0,
      };
    case types.DELIVERY_RESET_STATE:
      return INITIAL_STATE;
    default:
      return state;
  }
};
